/* globals zoomSdk */

interface ExternalLinkProps {
  href: string | undefined;
  className?: string;
  children: React.ReactNode;
  callback?: () => void;
}
const ExternalLink = ({ href, className = '', children, callback }: ExternalLinkProps) => {
  const handleClick = async (e: any) => {
    e.preventDefault();
    zoomSdk.openUrl({ url: href }).then(() => {
      if (callback) {
        callback();
      }
    }).catch((e: any) => {
      console.error(`Failed to open url ${href}`, e);
    });
  };

  return <a href={href} onClick={handleClick} className={`cursor-pointer ${className}`}>{children}</a>;
};

export default ExternalLink;
